import { memo } from 'react';
const SvgFastForward = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="fast-forward_svg__feather fast-forward_svg__feather-fast-forward"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m13 19 9-7-9-7v14zM2 19l9-7-9-7v14z" />
  </svg>
);
const Memo = memo(SvgFastForward);
export default Memo;
